export default "__VITE_ASSET__CfJKwOvt__"